if (!customElements.get('product-form')) {
customElements.define(
'product-form',
class ProductForm extends HTMLElement {
constructor() {
super();

this.form = this.querySelector('form');
this.variantIdInput.disabled = false;
this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
this.submitButton = this.querySelector('[type="submit"]');
this.submitButtonText = this.submitButton.querySelector('span');

if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

this.hideErrors = this.dataset.hideErrors === 'true';
}

onSubmitHandler(evt) {
evt.preventDefault();
if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

this.handleErrorMessage();

this.submitButton.setAttribute('aria-disabled', true);
this.submitButton.classList.add('loading');
this.querySelector('.loading__spinner').classList.remove('hidden');

const config = fetchConfig('javascript');
config.headers['X-Requested-With'] = 'XMLHttpRequest';
delete config.headers['Content-Type'];

const formData = new FormData(this.form);
if (this.cart) {
formData.append(
'sections',
this.cart.getSectionsToRender().map((section) => section.id)
);
formData.append('sections_url', window.location.pathname);
this.cart.setActiveElement(document.activeElement);
}
config.body = formData;
fetch(`${routes.cart_add_url}`, config)
.then((response) => response.json())
.then((response) => {
var timeInSecs;
var ticker;

function startTimer(secs) {
    timeInSecs = parseInt(secs, 10);
    localStorage.setItem("timer", timeInSecs); // Save initial time to localStorage
    if (ticker) clearInterval(ticker); // Clear existing ticker if any
    ticker = setInterval(tick, 1000);
    refreshTimerDisplay();
}

function tick() {
    if (timeInSecs > 0) {
        timeInSecs--;
        localStorage.setItem("timer", timeInSecs); // Update remaining time in localStorage
    } else {
        clearInterval(ticker);
        startTimer(10 * 60); // Restart with 10 minutes
    }
    refreshTimerDisplay();
}

function refreshTimerDisplay() {
    var secs = timeInSecs;
    var mins = Math.floor(secs / 60);
    secs %= 60;
    var pretty = (mins < 10 ? "0" : "") + mins + ":" + (secs < 10 ? "0" : "") + secs;

    document.getElementById("countdown").innerHTML = pretty;
      document.getElementById("countdowns").innerHTML = pretty;
}

function initializeTimer() {
    // Check if there's a saved timer in localStorage
    var savedTime = localStorage.getItem("timer");
    if (savedTime) {
        timeInSecs = parseInt(savedTime, 10);
    } else {
        timeInSecs = 10 * 60; // Default to 10 minutes
    }
    if (ticker) clearInterval(ticker); // Clear any previous ticker
    ticker = setInterval(tick, 1000); // Start the ticker
    refreshTimerDisplay();
}

// Initialize the timer when the window loads
window.onload = initializeTimer;

  
// Define reward thresholds
const rewardThresholds = [
{ amount: 12},
{ amount: 25},
{ amount: 50 },
{ amount: 75},
{ amount: 100 },
{ amount: 150 }
];

// Function to update the progress bar
const updateProgressBar = (cartTotal) => {
const progressBarFill = document.querySelector(".progress-bar-fill");
const remainingAmountSpan = document.querySelector(".remaining-amount");
const progressText = document.querySelector(".progress-text");

let progressPercentage = 0;
let nextReward = rewardThresholds.find((reward) => cartTotal < reward.amount);
if (cartTotal < 100 ) {
const prevReward = rewardThresholds[rewardThresholds.length - 1].amount;
// const range = nextReward.amount - prevReward.amount;
const progress =  Math.min((cartTotal / prevReward) * 100, 100); 
progressPercentage = progress + 15;
if (cartTotal < 12 ) {
$('.original_price').text(`$${cartTotal}`);
setTimeout(function(){
$(".progress-first-line").text("🎉Congratulation you've unlock the free shipping").fadeIn(400);
$(".progress-text").text(`Add $${(25 - cartTotal).toFixed(2)} To Your Cart And Save 5%!`).fadeIn(400);
$(".message_count").text(`Add $${(25 - cartTotal).toFixed(2)}  To Your Cart And Save 5%!`).fadeIn(400);
    $('.original_price_main').css('display','none');
$('.discount_title').css('display','none');
}, 2000);
}
else if(cartTotal < 25){
$('.original_price').text(`$${cartTotal}`);
setTimeout(function(){
$(".progress-first-line").text("🎉Congratulation you've unlock the free shipping").fadeIn(400);
$(".progress-text").text(`Add $${(25 - cartTotal).toFixed(2)} To Your Cart And Save 5%!`).fadeIn(400);
$(".message_count").text(`Add $${(25 - cartTotal).toFixed(2)} To Your Cart And Save 5%!`).fadeIn(400);
    $('.original_price_main').css('display','none');
$('.discount_title').css('display','none');
}, 2000);
}
else if(cartTotal < 52){
$('.original_price').text(`$${cartTotal}`);
setTimeout(function(){
$(".progress-first-line").text("🎉Congratulations! You've unlocked a 5% discount on your order.").fadeIn(400);
$(".progress-text").text(`Add $${(50 - cartTotal).toFixed(2)} To Your Cart And Save 10%!`).fadeIn(400);
$(".message_count").text(`Add $${(50 - cartTotal).toFixed(2)} To Your Cart And Save 10%!`).fadeIn(400);
  $('.original_price_main').css('display','flex');
$('.discount_title').css('display','flex');
}, 2000);
}
else if(cartTotal < 77){
$('.original_price').text(`$${cartTotal}`);
setTimeout(function(){
$(".progress-first-line").text("🎉Congratulations! You've unlocked a 10% discount on your order.").fadeIn(400);
$(".progress-text").text(`Add $${(75 - cartTotal).toFixed(2)} To Your Cart And Save 15%!`).fadeIn(400);
$(".message_count").text(`Add $${(75 - cartTotal).toFixed(2)} To Your Cart And Save 15%!`).fadeIn(400);
  $('.original_price_main').css('display','flex');
$('.discount_title').css('display','flex');

}, 2000);
}
else if(cartTotal < 102){
$('.original_price').text(`$${cartTotal}`);
setTimeout(function(){
$(".progress-first-line").text("🎉Congratulations! You've unlocked a 15% discount on your order.").fadeIn(400);
$(".progress-text").text(`Add $${(100 - cartTotal).toFixed(2)} To Your Cart And Save 20%!`).fadeIn(400);
$(".message_count").text(`Add $${(100 - cartTotal).toFixed(2)} To Your Cart And Save 20%!`).fadeIn(400);
  $('.original_price_main').css('display','flex');
$('.discount_title').css('display','flex');
}, 2000);
}
// else if(cartTotal < 152){
// setTimeout(function(){
// $(".progress-first-line").text("🎉Congratulation you've unlock the 20% discount on your product.").fadeIn(400);
// $(".progress-text").text('$150.01 amount needed to achieve next goal to Free 2-Day Shipping.').fadeIn(400);10
// }, 2000);
// }
} else {
$('.original_price').text(`$${cartTotal}`);
$(".progress-first-line").css('display','none');
$(".message_count").css('display','none');
  $('.original_price_main').css('display','flex');
$('.discount_title').css('display','flex');
progressPercentage = 100;
progressText.textContent = "🎉Congratulations! You've unlocked a 20% discount on your order. ";
}
if(progressBarFill){
progressBarFill.style.width = `${progressPercentage}%`;
  
}
};

// Fetch cart data and update progress bar
const fetchCartAndUpdate = () => {
fetch("/cart.js")
.then((response) => response.json())
.then((cart) => {
/* PL 2026-10-09: pl-multibuy.js owns multi-buy/discount UI (bundles = cart truth); legacy whole-cart copy skipped */
if (window.PLMultibuy) { window.PLMultibuy.refresh(); return; }
const cartTotal = cart.original_total_price / 100; // Convert cents to base currency
updateProgressBar(cartTotal);
});
};

// Run the update when the cart drawer is loaded
fetchCartAndUpdate();

// Listen for custom Shopify cart update events
document.addEventListener("cart:updated", fetchCartAndUpdate);


// document.dispatchEvent(new CustomEvent("cart:updated"));
if (response.status) {
publish(PUB_SUB_EVENTS.cartError, {
source: 'product-form',
productVariantId: formData.get('id'),
errors: response.errors || response.description,
message: response.message,
});
this.handleErrorMessage(response.description)

const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
if (!soldOutMessage) return;
this.submitButton.setAttribute('aria-disabled', true);
this.submitButtonText.classList.add('hidden');
soldOutMessage.classList.remove('hidden');
this.error = true;
return;
} else if (!this.cart) {
window.location = window.routes.cart_url;
return;
}

if (!this.error)
publish(PUB_SUB_EVENTS.cartUpdate, {
source: 'product-form',
productVariantId: formData.get('id'),
cartData: response,
});
this.error = false;
const quickAddModal = this.closest('quick-add-modal');
if (quickAddModal) {
document.body.addEventListener(
'modalClosed',
() => {
setTimeout(() => {
this.cart.renderContents(response);
});
},
{ once: true }
);
quickAddModal.hide(true);
} else {
this.cart.renderContents(response);
}
})
.catch((e) => {
console.error(e);
})
.finally(() => {
this.submitButton.classList.remove('loading');
if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
if (!this.error) this.submitButton.removeAttribute('aria-disabled');
this.querySelector('.loading__spinner').classList.add('hidden');
});
}

handleErrorMessage(errorMessage = false) {
if (this.hideErrors) return;

this.errorMessageWrapper =
this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
if (!this.errorMessageWrapper) return;
this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

if (errorMessage) {
this.errorMessage.textContent = errorMessage;
}
}

toggleSubmitButton(disable = true, text) {
if (disable) {
this.submitButton.setAttribute('disabled', 'disabled');
if (text) this.submitButtonText.textContent = text;
} else {
this.submitButton.removeAttribute('disabled');
this.submitButtonText.textContent = window.variantStrings.addToCart;
}
}

get variantIdInput() {
return this.form.querySelector('[name=id]');
}
}
);
}
